/**
 * Angular Imports.
 */
import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

/**
 * rxjs import
 */
import { Subscription } from 'rxjs';

/**
 * OwlCarousel Imports.
 */
import { OwlOptions } from 'ngx-owl-carousel-o';
/**
 * Services Imports.
 */
import { DataStorageService } from './../../dataservices/data-storage.service';
import { FunCollectionService } from './../../common/common-functions/fun-collection.service';
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { AnalyticsEventService } from './../../analytics-event/analytics-event.service';
import { MasterserviceService } from './../../dataservices/master-service/masterservice.service';
import { PostApiService } from './../../dataservices/post-api.service';

/**
 * Constants import.
 */
import { SCREEN_NAME, PRODUCT_TYPE_CONSTANT, NUMBERS, GRADIENT_DIRECTION, BOOKMARK_ACTION, SPLIT, ACTION_ON, CTA_TYPE, ACTION_TYPE, PRODUCT_TYPE_CONSTANT_NAME  } from './../../constants/app.constants';
import { EVENT_NAME} from '../../analytics-event/analytics.constant';
import { CLICK } from 'analytics2.0/dist/core/constants/analytic.interface';
/**
 * Model Imports.
 */
import { EcCard } from './../../interface/editors-choice/editors-choice.model';
import { HashTagSpecialty } from './../../interface/hashtag-specialty/hashtag-specialty.model';
import { AnalyticsInterface } from '../../analytics-event/analytics.model';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';
import { AppearedCards } from '../../directives/intersection/appear.interface';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';

/**
 * Editors choice card component.
 */
@Component({
  selector: 'app-editor-choice-card',
  templateUrl: './editor-choice-card.component.html',
  styleUrls: ['./editor-choice-card.component.scss']
})
export class EditorChoiceCardComponent implements OnInit, OnDestroy {

  /**
   * Owl carousel options.
   */
   public customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    navText: ['<i class="prev-slider position-absolute"></i>', '<i class="next-slider position-absolute"></i>'],
    nav: true,
    autoWidth: true,
    autoplay: false,
    responsive: {
      0: {
        items: 1
      },
      405: {
        items: 1.3
      },
      680: {
        items: 2.3
      }
    }
  };
  /**
   * Input used to get data inside the card where it is called.
   */
  @Input() editorChoiceCard: EcCard;

  /**
   *
   * EC card index
   // tslint:disable-next-line: no-redundant-jsdoc
   * @type {number}
   // tslint:disable-next-line: no-redundant-jsdoc
   * @memberof EditorChoiceCardComponent
   */
  @Input() ecIdx: number;

  /**
   *
   * Calling from page
   // tslint:disable-next-line: no-redundant-jsdoc
   * @type {string}
   // tslint:disable-next-line: no-redundant-jsdoc
   * @memberof EditorChoiceCardComponent
   */
  @Input() callingfrom: string;
  /**
   * Output is used to emit editor choice specialty in card.
   */
  @Output() feedSpecialty: EventEmitter<HashTagSpecialty> = new EventEmitter<HashTagSpecialty>();
  /**
   * Output is used to emit editor choice specialty in card.
   */
  @Output() feedSpecialtyInnerCard: EventEmitter<HashTagSpecialty> = new EventEmitter<HashTagSpecialty>();
  /**
   * Key used to store selected specialty name.
   */
  public selectedSpecialty: string;
  /**
   * Product type constants.
   */
  public productType = PRODUCT_TYPE_CONSTANT;
  /**
   * Product type constants.
   */
  public numericValue = NUMBERS;

  public actionOn = ACTION_ON;

  public ctaType = CTA_TYPE;

  /**
   *Gradient direction constant
   *
   // tslint:disable-next-line: no-redundant-jsdoc
   * @memberof EditorChoiceCardComponent
   */
  public gradientDirection = GRADIENT_DIRECTION;
  /**
   * Session time for analytics.
   */
  public sessiontime = { 'start_time': '', 'end_time': '' };
  /**
   *
   * bookmark loader
   * @memberof EditorChoiceCardComponent
   */
  public ec_bookmark_loader = false;

  /**
   * Constant for Event name
   */
  public eventName = EVENT_NAME;

  private subscriptions: Subscription = new Subscription();

  /**
   * Spilt symbol for the product type and id.
   */
  private splitProductTypeId = SPLIT;

  /**
   * Necessary instance.
   */
  constructor(
    private dss: DataStorageService,
    private fcs: FunCollectionService,
    private router: Router,
    private masterService: MasterserviceService,
    private postService: PostApiService,
    private fnCollectionService: FunCollectionService,
    private jwtSer: JwtDecodeService,
    public mls: NewLanguageService,
    private analyticSdk: Analytics,
    ) {
  }

  ngOnInit(): void {
    /**
     * Analytics object.
     */
    this.fcs.detectScreenChanges();
  }


  /**
   * Navigate to detail page of card.
   */
  viewDetails(): void {
    this.router.navigateByUrl('/editor-choice/' + this.editorChoiceCard.products[0].product_type_id);
  }

  /**
   * Get specialty aligned with feed.
   */
  getSpecialty(specialty): void {
    /**
     * Set analyics data on ngDestroy.
     */
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.FEED,this.editorChoiceCard.products[0].product_type_id, this.fcs.currentScreename, CTA_TYPE.TEXT, ACTION_TYPE.CLICK, ACTION_ON.SPECIALITY_HASTAG, null);
    this.feedSpecialty.emit(specialty);
    this.dss.specialty_filter = specialty;
    this.router.navigate(['/web/list']);
    const dateObject = new Date();
    this.sessiontime.start_time = dateObject.getTime().toString();
  }

  /**
   * Feed specialty from feed post card.
   */
  feedListFilteredBySpecialty(specialty): void {
    this.selectedSpecialty =
      specialty.speciality_name || specialty.category_name;
    this.feedSpecialtyInnerCard.emit(specialty);
    const specialtyVal =
      [{
        key: 'speciality',
        value: [specialty.speciality_id || specialty.category_id]
      }];
    this.dss.feed_filter.next(specialtyVal);
  }

  /**
   * Navigate to user profile.
   */
  navigateToUser(): void {
    const customId = this.editorChoiceCard.products[0].user_profile.custom_id;
    this.fcs.navigateToUserProfie(customId);
  }

  /**
   * profile pic clicked
   */
  profilePicClicked(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.INSIGHT_COLLECTOR, this.editorChoiceCard.products[0].product_type_id,this.fcs.currentScreename, CTA_TYPE.ICON, ACTION_TYPE.CLICK, ACTION_ON.PROFILE_ICON, null);
  }

  /**
   * product Bookmark
   */
  productBookmark(): boolean {
    if (this.masterService.isOnline === false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    if (this.ec_bookmark_loader) {
      return;
    }
    this.ec_bookmark_loader = true;
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.INSIGHT_COLLECTOR,this.editorChoiceCard.products[0].product_type_id, this.fcs.currentScreename, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.BOOKMARK, null);
    const action = (this.editorChoiceCard.products[0].is_bookmarked === NUMBERS.ZERO) ? BOOKMARK_ACTION.ADD : BOOKMARK_ACTION.DELETE;
    const bookmarkSubscription = this.postService.productBookmark(PRODUCT_TYPE_CONSTANT.EDITORS_CHOICE,
      this.editorChoiceCard.products[0].product_type_id, action).subscribe(resData => {
        this.masterService.bookmark_index.next(this.ecIdx);
        this.ec_bookmark_loader = false;
        this.jwtSer.decodeData(resData).then(data => {
          if (data['status'] === NUMBERS.ONE) {
            this.fnCollectionService.showSuccess(data['msg'], 'Success');
            this.editorChoiceCard.products[0].is_bookmarked = (action === BOOKMARK_ACTION.ADD) ? NUMBERS.ONE : NUMBERS.ZERO;
            if (action === BOOKMARK_ACTION.DELETE) {
              this.dss.bookmarkRemove.next(this.ecIdx);
            }

          } else if (data['status'] === NUMBERS.ZERO) {
            this.fnCollectionService.showError(data['msg'], 'Error');
            this.fnCollectionService.errorHandeler(data);
            this.ec_bookmark_loader = false;
            return;
          }
        }, () => {
          this.ec_bookmark_loader = false;
        });
      });
    this.subscriptions.add(bookmarkSubscription);
  }

  /**
   * Called once, before the instance is destro
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  /**
   * @EventHandler for sending analytic event
   */
  sendAnalyticEvents(actionOn, ctaType): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.INSIGHT_COLLECTOR,this.editorChoiceCard.products[0].product_type_id,this.fcs.currentScreename,ctaType, ACTION_TYPE.CLICK,actionOn, null);
  }

  /**
   * Get the appeared card product type and id.
   */
  getAppearedIds(card): string {
    if (card.product_type === PRODUCT_TYPE_CONSTANT.EDITORS_CHOICE) {
      return `${card.product_type}${this.splitProductTypeId}${card.products[0].product_type_id}`;
    }
    return `${card.product_type}${this.splitProductTypeId}${card.product_type_id}`;
  }

  /**
   * Collects all the appeared cards on the DOM view.
   */
  onCardAppear(cards: AppearedCards): void {
    this.fcs.onHorizontalCardAppear(cards, this.callingfrom);
  }
}
